var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"link-item",attrs:{"href":"https://lcpcloud.com/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Privacy Policy")])
}
var staticRenderFns = []

export { render, staticRenderFns }